import Vue from 'vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

export default function ({ app }) {
  Vue.use(VueLodash, { name: 'custom', lodash })
}
